module.exports = __webpack_public_path__ + "static/media/logo-white.8d5fb517.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/logo-white.svg
// module id = 379
// module chunks = 2